const PROPER_NAME_DELIMITER = ' > '
const SLUG_CHUNK_DELIMITER = '~'

export {
    PROPER_NAME_DELIMITER,
    SLUG_CHUNK_DELIMITER,
}